import { render, staticRenderFns } from "./ReviewTypeCard.vue?vue&type=template&id=ee695a0c&scoped=true&"
import script from "./ReviewTypeCard.vue?vue&type=script&lang=js&"
export * from "./ReviewTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTypeCard.vue?vue&type=style&index=0&id=ee695a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee695a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
